import { useState } from "react";
import { Box, Button, Modal, TextField, Chip } from "@mui/material";
import {
  addShareholder,
  fetchShareholderList,
  updateShareholder,
} from "../service/ConfigService";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const CreateShareholderModal = ({
  modalProps = {},
  onClose,
  existingShareholder = null,
}) => {
  const [shareholder, setShareholder] = useState(existingShareholder);
  const [isNotFound, setisNotFound] = useState(false);
  const [step, setStep] = useState(existingShareholder ? 2 : 1);
  const [sid, setSID] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateButShowCreateMessage, setUpdateButShowCreateMessage] =
    useState();

  const fetchShareholder = async (e) => {
    e.preventDefault();
    const fetcher = fetchShareholderList(
      setLoading,
      {},
      {
        sid: sid,
        holding_status: "ACTIVE,INACTIVE",
      },
      (resp) => {
        const result = resp?.data?.shareholders;
        if (result && result.length > 0) {
          setShareholder(result[0]);
          setisNotFound(false);
        } else {
          setShareholder({
            sid: sid,
          });
          setisNotFound(true);
        }
      },
      (err) => console.log(err),
    );
    await fetcher();
  };

  const submitShareholder = async (e) => {
    e.preventDefault();
    if (!isNotFound) {
      const updater = updateShareholder(
        setLoading,
        shareholder.sid,
        {
          is_affiliated: true,
          position: shareholder.position,
        },
        (resp) => {
          onClose({
            title: "Success",
            desc: `Successfully ${
              updateButShowCreateMessage ? "added new" : "updated"
            } shareholder.`,
            type: "success",
          });
        },
        (err) => {
          onClose({
            title: "Error",
            desc: `Failed to ${
              updateButShowCreateMessage ? "add new" : "update"
            } shareholder.`,
            type: "error",
          });
        },
      );
      await updater();
    } else {
      const adder = addShareholder(
        setLoading,
        {
          sid: shareholder.sid,
          name: shareholder.name,
          is_affiliated: true,
          position: shareholder.position,
        },
        (resp) => {
          onClose({
            title: "Success",
            desc: "Successfully added new shareholder.",
            type: "success",
          });
        },
        (err) => {
          onClose({
            title: "Error",
            desc: "Failed to add new shareholder.",
            type: "error",
          });
        },
      );
      await adder();
    }
  };
  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          overflow: "scroll",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          minWidth: 500,
        }}
      >
        <div className='flex flex-col'>
          <div className='flex flex-row gap-2 font-semibold px-4 py-5 border-b'>
            <CloseOutlinedIcon className='cursor-pointer' onClick={onClose} />
            <h2>
              {existingShareholder
                ? "Edit Affiliated Shareholder"
                : "Add New Affiliated Shareholder"}
            </h2>
          </div>
          {step === 1 && (
            <>
              <div className='form-input mx-4 my-5'>
                <form action='#' onSubmit={fetchShareholder}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex flex-row gap-1'>
                      <p className='form-input-label text-sm text-[#5F737F]'>
                        SID
                      </p>
                      <span className='text-red-500 text-sm'>*</span>
                    </div>
                    <div className='grid grid-cols-2 gap-2'>
                      <TextField
                        type='text'
                        placeholder='SID'
                        value={sid}
                        onChange={({ target: { value } } = {}) => {
                          setSID(value);
                        }}
                        required={true}
                        inputProps={{
                          minLength: 1,
                        }}
                      />
                      <button
                        type='submit'
                        className='font-semibold my-auto text-[#556FB5] cursor-pointer text-left'
                      >
                        Check
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              {isNotFound && (
                <div className='mx-4 my-5'>
                  <p className='text-xs'>
                    Shareholder not found.{" "}
                    <span
                      className='text-[#556FB5] font-semibold cursor-pointer'
                      onClick={() => {
                        setStep(2);
                      }}
                    >
                      Click here
                    </span>{" "}
                    to manually add the shareholder.
                  </p>
                </div>
              )}
              {shareholder?.name && !loading && (
                <div className='mx-4 my-5 py-5 grid grid-cols-3 gap-2 border-t border-gray-400 text-xs'>
                  <p className='text-[#5F737F]'>Shareholder name:</p>
                  <p className='col-span-2 font-bold'>{shareholder.name}</p>
                  <p className='text-[#5F737F]'>Shareholder SID:</p>
                  <p className='col-span-2 font-bold'>{shareholder.sid}</p>
                  {!shareholder.is_affiliated && (
                    <Button
                      variant='contained'
                      onClick={() => {
                        setStep(2);
                        setUpdateButShowCreateMessage(true);
                      }}
                      className='!bg-[#556FB5] text-xs col-start-3'
                    >
                      Next
                    </Button>
                  )}
                  {shareholder.is_affiliated && (
                    <Chip label='Already Added' color='success' />
                  )}
                </div>
              )}
            </>
          )}

          {step === 2 && (
            <>
              <div className='form-input mx-4 my-5'>
                <form
                  action='#'
                  onSubmit={submitShareholder}
                  className='grid grid-cols-2 gap-2'
                >
                  <div className='flex flex-col gap-2'>
                    <div className='flex flex-row gap-1'>
                      <p className='form-input-label text-sm text-[#5F737F]'>
                        SID
                      </p>
                      <span className='text-red-500 text-sm'>*</span>
                    </div>
                    <div className=''>
                      <TextField
                        type='text'
                        placeholder='SID'
                        value={shareholder.sid || sid}
                        onChange={({ target: { value } } = {}) => {
                          setShareholder({
                            ...shareholder,
                            sid: value,
                          });
                        }}
                        disabled={true}
                        required
                        className='w-full'
                      />
                    </div>
                  </div>
                  <div className='flex flex-col gap-2'>
                    <div className='flex flex-row gap-1'>
                      <p className='form-input-label text-sm text-[#5F737F]'>
                        Name
                      </p>
                      <span className='text-red-500 text-sm'>*</span>
                    </div>
                    <div className=''>
                      <TextField
                        type='text'
                        placeholder='Name'
                        value={shareholder.name}
                        onChange={({ target: { value } } = {}) => {
                          setShareholder({
                            ...shareholder,
                            name: value,
                          });
                        }}
                        disabled={!isNotFound}
                        required
                        className='w-full'
                      />
                    </div>
                  </div>
                  <div className='flex flex-col gap-2'>
                    <div className='flex flex-row gap-1'>
                      <p className='form-input-label text-sm text-[#5F737F]'>
                        Position (related to issuer)
                      </p>
                      <span className='text-red-500 text-sm'>*</span>
                    </div>
                    <div className=''>
                      <TextField
                        type='text'
                        placeholder='Position'
                        value={shareholder.position}
                        onChange={({ target: { value } } = {}) => {
                          setShareholder({
                            ...shareholder,
                            position: value,
                          });
                        }}
                        required
                        inputProps={{
                          minLength: 2,
                        }}
                        className='w-full'
                      />
                    </div>
                  </div>
                  <div></div>
                  <div className='col-start-2 pl-[50%]'>
                    <Button
                      variant='contained'
                      className='!bg-[#556FB5] text-xs w-full'
                      type='submit'
                      disabled={loading}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default CreateShareholderModal;
